var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled } from '../theme-provider';
import { Text, TokenTextAppearance, TokenTextColor, TextTag, WhiteSpace, } from '../text';
import { getCommonProps } from '../helpers/common-props';
const StyledCharacterCounter = styled.span.withConfig({ displayName: "StyledCharacterCounter", componentId: "sc-omfthb" }) `margin-inline-start:auto;color:${({ theme }) => theme.colors.content.tertiary};`;
export const CharacterCounter = (props) => {
    const { limit, value = 0 } = props, rest = __rest(props, ["limit", "value"]);
    const commonProps = getCommonProps(props);
    return (React.createElement(StyledCharacterCounter, Object.assign({ "aria-hidden": true }, commonProps, rest),
        React.createElement(Text, { tag: TextTag.span, color: TokenTextColor.inherit, appearance: TokenTextAppearance.label100, whiteSpace: WhiteSpace.nowrap },
            value,
            " / ",
            limit)));
};
